function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.786 3.8H4.727a.905.905 0 00-.909.9v12.6c0 .497.407.9.91.9h14.545a.905.905 0 00.909-.9V7.4c0-.497-.407-.9-.91-.9h-8.18a.912.912 0 01-.757-.4L8.786 3.8zm2.791.9h7.696C20.779 4.7 22 5.909 22 7.4v9.9c0 1.491-1.221 2.7-2.727 2.7H4.727C3.221 20 2 18.791 2 17.3V4.7C2 3.209 3.221 2 4.727 2h4.546a.91.91 0 01.756.4l1.548 2.3z"
});

var SvgFolder = function SvgFolder(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/folder.f8a549d7.svg";
export { SvgFolder as ReactComponent };